import { useEffect } from "react";

function Error({ error }: { error: Error }) {

  useEffect(() => {
    // 上报路由错误到 Sentry (仅在生产环境)
    if (import.meta.env.PROD) {
      import("@sentry/react").then((Sentry) => {
        Sentry.captureException(error, {
          tags: { component: 'route-error' }
        });
      });
    }
  }, [error]);

  return (
    <div>
      <h1>系统错误</h1>
      <p>抱歉，系统发生错误，请稍后重试。</p>
    </div>
  )
}

export default Error